import { ButtonTertiary } from '@spotify-internal/encore-web';
import { useTranslation } from 'react-i18next';
import { FunctionComponent } from 'react';

const style = { paddingLeft: '0px' };

type BackButtonProps = {
  handleBackButton: () => void;
};

const BackButton: FunctionComponent<BackButtonProps> = ({ handleBackButton }) => {
  const { t } = useTranslation('infringement_claim_form');

  return (
    <ButtonTertiary style={style} onClick={handleBackButton}>
      <span className="rtl-flip">&larr;</span> {t('back_button_label')}
    </ButtonTertiary>
  );
};

export default BackButton;
